import React from "react";
import PublicPage from "../../public/PublicPage";
import TransactionRecordPage from "../../public/pages/TransactionRecordPage";

const TransactionRecord = () => (
  <PublicPage>
    <TransactionRecordPage />
  </PublicPage>
);

export default TransactionRecord;
